import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";
import Brandmark from "./Brandmark";
import FullLogo from "./FullLogo";
import Wordmark from "./Wordmark";

type LogoType = "fullLogo" | "brandmark" | "wordmark";
type Size = "sm" | "md" | "lg";

function getSizeClassName(size: Size = "md", type?: LogoType) {
  if (type === "fullLogo") {
    if (size === "sm") return "w-[110px]";
    if (size === "md") return "w-[160px]";
    if (size === "lg") return "w-[240px]";
  }
  if (type === "brandmark") {
    if (size === "sm") return "w-[20px]";
    if (size === "md") return "w-[30px]";
    if (size === "lg") return "w-[45px]";
  }

  if (type === "wordmark") {
    if (size === "sm") return "w-[86px]";
    if (size === "md") return "w-[130px]";
    if (size === "lg") return "w-[195px]";
  }
  return undefined;
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  size?: Size;
  type?: LogoType;
}

const NumerousLogo = ({ size, type, className, ...props }: Props) => {
  return (
    <div {...props} className={cn(className, getSizeClassName(size, type))}>
      {type === "fullLogo" && <FullLogo />}
      {type === "brandmark" && <Brandmark />}
      {type === "wordmark" && <Wordmark />}
    </div>
  );
};

export default NumerousLogo;
